import { render, staticRenderFns } from "./matchRecordDetail.vue?vue&type=template&id=7cb10051&scoped=true&"
import script from "./matchRecordDetail.vue?vue&type=script&lang=js&"
export * from "./matchRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./matchRecordDetail.vue?vue&type=style&index=0&id=7cb10051&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb10051",
  null
  
)

export default component.exports